import '../configuracoes.css'
import trashIcon from '../../../imagens/trash.png'

import toast from 'react-hot-toast';
import { useState, useEffect } from 'react';

import { servDelPontoFacultativo, servGetPontosFacultativosMes } from '../../../servicos/servicosEmRotasPrivadas/pontoFacultativo';
import { toastErrorPydantic } from '../../../util/toast_pydantic';

import DataMesControlled from '../../DataMesControlled';

function ConsultaPontoFacultativo() {

    console.log('### Iniciando ConsultaPontoFacultativo ###');

    const [mesReferencia, setMesReferencia] = useState(null)
    const [pontosFacultativos, setPontosFacultativos] = useState(null)

    const getPontosFacultativosMes = async () => {
        try {
            const response = await toast.promise(
                servGetPontosFacultativosMes(mesReferencia),
                { loading: 'Buscandos pontos facultativos do mês...' }
            )
            setPontosFacultativos(response.pontosFacultativos)
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    useEffect(() => {
        if (mesReferencia) getPontosFacultativosMes();
    }, [mesReferencia]);

    const delPontoFacultativo = async (pontoFacultativoId) => {
        try {
            const response = await toast.promise(
                servDelPontoFacultativo(pontoFacultativoId),
                { loading: 'Excluindo ponto facultativos...' }
            )
            getPontosFacultativosMes()
            toast.success(response.message)
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    return (
        <div className='container-configuracoes div-com-borda'>
            <div>
                <strong>
                    <p className='m-0 fs-5'>Informe o mês para consultar pontos facultativos cadastrados no banco</p>
                </strong>
                <div className='d-flex flex-column gap-3'>
                    <div className="col-12 col-sm-3 pt-3">
                        <label htmlFor="mes" className="form-label">Mês</label>
                        <DataMesControlled
                            id="mes"
                            value={mesReferencia}
                            onChange={setMesReferencia}
                            getUltimoDia={false}
                        />
                    </div>
                    {
                        pontosFacultativos !== null && (
                            pontosFacultativos.length > 0
                                ? <div className="table-responsive">
                                    <table className="table" >
                                        <thead>
                                            <tr>
                                                <th>Descrição</th>
                                                <th>Data</th>
                                                <th>Excluir</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pontosFacultativos.map((pontoFacultativo) => (
                                                <tr
                                                    key={pontoFacultativo.id}
                                                >
                                                    <td>{pontoFacultativo.descricao}</td>
                                                    <td>{pontoFacultativo.data}</td>
                                                    <td>
                                                        <img
                                                            className='trash-icon'
                                                            style={{ 'width': '1.5em' }}
                                                            alt='icone de lixeira/exclusao'
                                                            src={trashIcon}
                                                            onClick={() => delPontoFacultativo(pontoFacultativo.id)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                : <p className='fs-5 m-0'>Não há pontos facultativos para o mês selecionado</p>
                        )
                    }
                </div>
            </div>
        </div >
    )
}

export default ConsultaPontoFacultativo
